var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethescopeLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 42,
    viewBox: "0 0 37 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4690_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4691_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4692_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14893_",
    d: "M5.40926 3.88956C6.40708 3.88956 7.21597 3.12239 7.21597 2.17604C7.21597 1.22969 6.40708 0.462524 5.40926 0.462524C4.41143 0.462524 3.60254 1.22969 3.60254 2.17604C3.60254 3.12239 4.41143 3.88956 5.40926 3.88956Z",
    fill: "#FFFEFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4693_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14892_",
    d: "M9.92071 22.6972C0.72485 22.6972 0 16.0278 0 9.87147C0 2.86349 3.97045 1.3244 5.40933 1.3244C5.95026 1.3244 6.30728 1.663 6.30728 2.17603C6.30728 2.68906 5.95026 3.02766 5.40933 3.02766C4.51138 3.02766 1.80672 4.22815 1.80672 9.87147C1.80672 16.8795 3.0725 20.9837 9.92071 20.9837C10.4616 20.9837 10.8187 21.3223 10.8187 21.8353C10.8187 22.1842 10.4616 22.6972 9.92071 22.6972Z",
    fill: "#FFFEFE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4694_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4695_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14889_",
    d: "M14.4322 3.8793C13.3503 3.8793 12.6255 3.19184 12.6255 2.16578C12.6255 1.13972 13.3503 0.462524 14.4322 0.462524C15.5141 0.462524 16.2389 1.14998 16.2389 2.17604C16.2389 3.2021 15.5141 3.8793 14.4322 3.8793ZM14.4322 2.17604H13.5343H14.4322Z",
    fill: "#FFFEFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4696_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14888_",
    d: "M22.546 41.5049H17.1367C12.6253 41.5049 9.02271 38.0881 9.02271 33.8094V21.8353C9.02271 21.3223 9.37972 20.9837 9.92065 20.9837C16.7689 20.9837 18.0346 16.8794 18.0346 9.87147C18.0346 4.22815 15.33 3.02766 14.432 3.02766C13.8911 3.02766 13.5341 2.68906 13.5341 2.17603C13.5341 1.663 13.8911 1.3244 14.432 1.3244C15.8709 1.3244 19.8414 2.86349 19.8414 9.87147C19.8414 15.8534 19.1165 22.1842 10.8294 22.6972V33.8094C10.8294 37.062 13.718 39.7913 17.1367 39.7913H22.546C25.9755 39.7913 28.8533 37.0518 28.8533 33.8094V32.0959C28.8533 31.5829 29.2103 31.2443 29.7513 31.2443C30.2922 31.2443 30.6492 31.5829 30.6492 32.0959V33.8094C30.66 37.9137 27.0466 41.5049 22.546 41.5049Z",
    fill: "#FFFEFE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4697_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14885_",
    d: "M29.7514 32.9578C26.3219 32.9578 23.4441 30.2182 23.4441 26.9759C23.4441 23.7335 26.3327 20.994 29.7514 20.994C33.1701 20.994 36.0587 23.7335 36.0587 26.9759C36.0587 30.2182 33.1809 32.9578 29.7514 32.9578ZM29.7514 22.6972C27.2306 22.6972 25.24 24.5749 25.24 26.9759C25.24 29.3666 27.2198 31.2545 29.7514 31.2545C32.2721 31.2545 34.2628 29.3769 34.2628 26.9759C34.2628 24.5749 32.2829 22.6972 29.7514 22.6972Z",
    fill: "#FFFEFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4698_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14882_",
    d: "M29.7513 29.5307C28.3124 29.5307 27.0466 28.3302 27.0466 26.9656C27.0466 25.6009 28.3124 24.4004 29.7513 24.4004C31.1902 24.4004 32.456 25.6009 32.456 26.9656C32.456 28.3302 31.201 29.5307 29.7513 29.5307ZM29.7513 26.1139C29.2104 26.1139 28.8533 26.4525 28.8533 26.9656C28.8533 27.4786 29.2104 27.8172 29.7513 27.8172C30.2922 27.8172 30.6492 27.4786 30.6492 26.9656C30.6601 26.4525 30.2922 26.1139 29.7513 26.1139Z",
    fill: "#FFFEFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethescopeLogo);
export default __webpack_public_path__ + "static/media/stethescope_logo.835ef93d3d6e16f7286250059d0c7b26.svg";
export { ForwardRef as ReactComponent };